import React from 'react';
import {Form, Textarea, List} from 'components';
import {useNamedSelector} from 'helpers';

export function Growth() {
  return (
    <Form {...useNamedSelector('clarity.form', { name: 'growth' })}>
      <List tiny-gutter>
        <List.Title>Where are you stuck in your life?</List.Title>
        <Textarea single name="1" />
        <List.Title>What would it take to get unstuck?</List.Title>
        <Textarea single name="2" />
        <List.Title>What is difficult for you to admit about how you are living your life?</List.Title>
        <Textarea single name="3" />
        <List.Title>Where have you grown in the last year?</List.Title>
        <Textarea single name="4" />
        <List.Title>Which of your accomplishments are you most proud of?</List.Title>
        <Textarea single name="5" />
        <List.Title>What do you dream of accomplishing?</List.Title>
        <Textarea single name="6" />
        <List.Title>If you could change one thing about your behavior or habits, what would it be?</List.Title>
        <Textarea single name="7" />
        <List.Title>What have you always wanted to do but were afraid to try?</List.Title>
        <Textarea single name="8" />
      </List>
    </Form>
  );
}
